import Modal from "react-bootstrap/Modal";
import { IoClose } from "react-icons/io5";
import { useEffect } from "react";

export const NewconfirmationModal = (props) => {
    const { timeoutDuration = 5000 } = props; // Default timeout: 5 seconds (5000ms)

    useEffect(() => {
      // Create a timer to automatically close the modal
      const timeoutId = setTimeout(() => {
        props.onHide();
      }, timeoutDuration);
  
      // Clean up the timer on component unmount or when modal closes
      return () => clearTimeout(timeoutId);
    }, [props.onHide, timeoutDuration]);
  
  const handleConfirm = () => {
    if (props.confirmation) {
      props.confirmation(true);
    }
    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="confirmation-modal shadow-lg rounded-3"
    >
      <Modal.Header className="border-0 bg-light d-flex align-items-center px-4 py-3 position-relative">
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="w-100 text-center fw-bold text-dark"
          style={{ marginRight: "50px", padding: "10px 0" }}
        >
          {props.modalMessage}
        </Modal.Title>
        <button 
          onClick={props.onHide} 
          className="position-absolute top-0 end-0 mt-2 me-2 border-0 d-flex align-items-center justify-content-center"
          style={{ 
            width: "40px", 
            height: "40px", 
            background: "transparent", 
            transition: "0.3s", 
            fontSize: "20px", 
            fontWeight: "bold", 
            color: "#000", 
            borderRadius: "5px",
            padding: "5px"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#dc3545";
            e.currentTarget.style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = "#000";
          }}
        >
          <IoClose size={20} />
        </button>
      </Modal.Header>
      <Modal.Footer className="border-0 d-flex justify-content-center gap-3 pb-4">
        {props.operationType && props.operationType.length > 0 && (
          <button onClick={handleConfirm} className="btn btn-success px-5 py-2 fw-bold shadow-sm rounded-pill">
            {props.operationType}
          </button>
        )}
        
      </Modal.Footer>
    </Modal>
  );
};

export default NewconfirmationModal;